import { Box, BoxProps } from '@chakra-ui/react';

type Props = Omit<BoxProps, 'w' | 'width' | 'm' | 'margin'>;

/**
 * 画面横幅いっぱいのBoxコンポーネント
 */
export default function FullWidthBox(props: Props) {
  return <Box w="100vw" m="0 calc(50% - 50vw)" {...props} />;
}
